import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { AppUser } from 'Src/views/App/App';
import { Component } from 'react';
import { Loader } from 'Src/components/Loader/Loader';
import { ClubBookingCard } from 'Src/components/ClubBookingCard/ClubBookingCard';
import { EventInvitationMessage } from 'Src/models/message';
import { MessageField } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { ClubInvitationForm } from 'Src/components/ClubInvitationForm/ClubInvitationForm';
import { Child } from 'Src/models/child';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, CARD_LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION,
  getSearchFilter,
  getSearchOrder,
  getOrder
} from 'Src/helpers/table/table';
import {
  getParentArchiveMessages,
  getParentArchiveMessagesCount,
  cancelRejectionOfParentClubInvitation,
  updateParentClubAnswers
} from 'Src/helpers/service/parent/messagesTable';
import { getChildren } from 'Src/helpers/service/parent/children';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { INVITE_TYPE } from 'Src/consts/invite';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Map } from 'Src/components/Map/Map';
import { ClubBookingDeatils } from '../ClubBookingDetails/ClubBookingDetails';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { ItemsBar } from 'Src/views/GenericView/ParentView/Calendar/ItemsBar';
import { ParentPageHeader } from '../../components/ParentPageHeader';
import '../../components/ParentLists.scss';
import {
  ClubSectionCounts,
  clubSectionTabs,
  currentAcademicYearRange,
  getParentClubSectionCounts,
  hasClubSectionContent
} from 'Src/helpers/club/clubSectionCounts';

const DEFAULT_SEARCH = {
  order: 'isActionPerformedSetAt:DESC'
};

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  mode?: 'current' | 'previous';
  setNeedUpdate?: () => void;
}

const previousAcademicYearsRange = () => {
  const current = currentAcademicYearRange();
  const boundary = new Date(`${current.from}T00:00:00Z`);
  boundary.setUTCDate(boundary.getUTCDate() - 1);
  return { to: boundary.toISOString().slice(0, 10) };
};

interface State {
  items: EventInvitationMessage[];
  selectedItem: EventInvitationMessage | undefined;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  children: Child[];
  basePath: string;
  isViewMapModalOpen: boolean;
  isShowDetailsModalOpen: boolean;
  sectionCounts?: ClubSectionCounts;
  isEditResponseOpen?: boolean;
}

const FILTER_FIELDS_ALL: ColumnDefinition[] = [
  { text: 'Children', field: 'childIdList', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false },
  { text: 'Club name', field: 'clubName', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Activity/Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Invitation date', field: 'createdAt', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  {
    text: 'Club start date',
    field: 'schedule.startDate',
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: [''],
    isSort: false
  },
  { text: 'Status', field: 'invitationStatus', type: FILTER_TYPE.TEXT, accessor: [''], isSort: true },
  { text: 'Days', field: 'days', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false }
];

const ALL_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export class ClubBookingArchive extends Component<Props, State> {
  private loadRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      selectedItem: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      children: [],
      isViewMapModalOpen: false,
      isShowDetailsModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search || nextProps.mode !== this.props.mode) {
      this.setState({ isLoading: true });
      this.setItems(nextProps);
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const src = { ...(f || {}) };
    const out: any = {};

    const trimOrUndef = (v?: any) => {
      if (typeof v === 'string') {
        const s = v.trim();
        return s || undefined;
      }
      if (v && typeof v === 'object') {
        const like = String((v as any).like ?? (v as any).$regex ?? '').trim();
        return like || undefined;
      }
      return undefined;
    };

    const toIso = (s?: string) => {
      if (!s) return s;
      const m1 = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m1) return `${m1[3]}-${m1[2]}-${m1[1]}`;
      if (m2) return s;
      return s;
    };

    const clubName = trimOrUndef(src.clubName);
    const sport = trimOrUndef(src.sport);
    if (clubName) out.clubName = clubName;
    if (sport) out.sport = sport;

    if (typeof src.createdAt === 'string') {
      out.createdAt = { from: toIso(src.createdAt), to: undefined };
    } else if (src.createdAt && (src.createdAt.from || src.createdAt.to)) {
      out.createdAt = { from: toIso(src.createdAt.from), to: toIso(src.createdAt.to) };
    }
    if (src['schedule.startDate'] && (src['schedule.startDate'].from || src['schedule.startDate'].to)) {
      out['schedule.startDate'] = {
        from: toIso(src['schedule.startDate'].from),
        to: toIso(src['schedule.startDate'].to)
      };
    }

    if (Array.isArray(src.days)) {
      const norm = src.days
        .map((d: string) =>
          String(d)
            .trim()
            .toUpperCase()
        )
        .filter(Boolean);
      if (norm.length) out.days = norm;
    } else if (typeof src.days === 'string') {
      const v = String(src.days)
        .trim()
        .toUpperCase();
      if (v) out.days = [v];
    }

    if (Array.isArray(src.childIdList) && src.childIdList.length) {
      out.childIdList = src.childIdList;
    }

    if (typeof src.invitationStatus === 'string' && src.invitationStatus.trim()) {
      out.invitationStatus = src.invitationStatus.trim().toUpperCase();
    }
    return out;
  };

  private setItems(props: Props = this.props) {
    const requestId = ++this.loadRequestId;
    const { user, location } = props;
    const search = parse(location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '' as TABLE_SORT_DIRECTION;
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      const [field, dir] = (search.order as string).split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    } else if (typeof DEFAULT_SEARCH.order === 'string') {
      const [field, dir] = DEFAULT_SEARCH.order.split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    }

    const sortByFieldExist = !!sortFieldName;
    const sortDirectionExist = !!sortDirection;

    const rawFilters = getFilters2(FILTER_FIELDS_ALL, search);

    const daysFromUrl = propz.get(search, ['filter'])
      ? (() => {
          try {
            const parsed = JSON.parse(decodeURIComponent(String(search.filter)));
            return Array.isArray(parsed.where?.days) ? parsed.where.days : undefined;
          } catch {
            return undefined;
          }
        })()
      : undefined;

    const likeFromUrl = (key: string): string | undefined => {
      const blob = propz.get(search, ['filter']);
      if (!blob) return undefined;
      try {
        const parsed = JSON.parse(decodeURIComponent(String(blob)));
        const v = parsed?.where?.[key];
        if (!v) return undefined;
        if (typeof v === 'string') return v.trim() || undefined;
        if (typeof v === 'object') {
          return String(v.like ?? v.$regex ?? '').trim() || undefined;
        }
        return undefined;
      } catch {
        return undefined;
      }
    };
    const clubNameFromUrl = likeFromUrl('clubName');
    const sportFromUrl = likeFromUrl('sport');

    const uiFiltersBase = {
      ...rawFilters,
      ...(daysFromUrl ? { days: daysFromUrl } : {}),
      ...(clubNameFromUrl ? { clubName: clubNameFromUrl } : {}),
      ...(sportFromUrl ? { sport: sportFromUrl } : {})
    };
    const hasAppliedArchiveFilters = Object.keys(search).some(key => key !== 'page' && key !== 'order');
    if (!uiFiltersBase.createdAt && props.mode !== 'previous') {
      uiFiltersBase.createdAt = currentAcademicYearRange();
    }

    if (props.mode === 'previous' && !hasAppliedArchiveFilters) {
      return getChildren(user).then(children => {
        if (requestId !== this.loadRequestId) return;
        this.setState(
          {
            items: [],
            currentPage: FIRST_PAGE,
            children,
            filters: uiFiltersBase,
            sortDirection,
            sortFieldName,
            total: 0,
            basePath: location.pathname,
            isLoading: false
          },
          () => {
            getParentClubSectionCounts(user, { children })
              .then(sectionCounts => this.setState({ sectionCounts }))
              .catch(() => undefined);
          }
        );
      });
    }

    const filtersForQuery = this.normalizeFiltersForQuery(uiFiltersBase);
    const { createdAt, invitationStatus, ...rest } = filtersForQuery;
    const academic = currentAcademicYearRange();
    const boundedCreatedAt =
      props.mode === 'previous'
        ? {
            ...(createdAt || {}),
            to: createdAt?.to && createdAt.to < academic.from ? createdAt.to : previousAcademicYearsRange().to
          }
        : {
            ...(createdAt || {}),
            from: createdAt?.from && createdAt.from > academic.from ? createdAt.from : academic.from,
            to: createdAt?.to && createdAt.to < academic.to ? createdAt.to : academic.to
          };

    const where = {
      kind: 'ClubParticipantInviteMessage',
      ...rest,
      createdAt: boundedCreatedAt,
      ...(invitationStatus ? { invitationStatus } : {})
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const countWhere = { ...where };
    delete countWhere.childIdList;

    const getItemsPromise = getParentArchiveMessages(user, serverQueryFilter);
    const getItemsCountPromise = getParentArchiveMessagesCount(user, countWhere, true);
    const getChildrenPromise = getChildren(user);

    let children: Child[] = [];

    return BPromise.all([getItemsPromise, getItemsCountPromise, getChildrenPromise]).then(
      ([clubBookings, clubBookingsCountObj, _children]) => {
        if (requestId !== this.loadRequestId) return;
        const hasChildSelection = Array.isArray(uiFiltersBase.childIdList) && uiFiltersBase.childIdList.length > 0;
        const itemCounts = clubBookingsCountObj.itemCounts || {};
        const matchingTotal = hasChildSelection && clubBookingsCountObj.itemCounts
          ? uiFiltersBase.childIdList.reduce((sum, childId) => sum + (itemCounts[String(childId)] || 0), 0)
          : Number(clubBookingsCountObj.count);
        children = (_children || []).map(child => ({ ...child, itemCount: itemCounts[String(child.id)] || 0 }));

        const uiFiltersWithChild = hasChildSelection
          ? uiFiltersBase
          : { ...uiFiltersBase, childIdList: children.map(c => c.id) };

        this.setState(
          {
            items: clubBookings,
            currentPage: page,
            children,
            filters: uiFiltersWithChild,
            sortDirection,
            sortFieldName,
            total: matchingTotal,
            basePath: location.pathname,
            isLoading: false
          },
          () => {
            getParentClubSectionCounts(user, { children })
              .then(sectionCounts => this.setState({ sectionCounts }))
              .catch(() => undefined);
          }
        );
      }
    );
  }

  private setCurrentPageParams = (currentPage: number): void => {
    const { filters, sortFieldName, sortDirection, basePath } = this.state;
    const parts: string[] = [];

    if (currentPage !== 1) parts.push(`page=${currentPage}`);
    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: basePath, search: parts.join('&') });
  };

  private onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortFieldName, basePath } = this.state;
    const order = getOrder(sortField, sortDirection, sortFieldName);

    const parts: string[] = [`order=${sortField}:${order}`];

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: basePath, search: parts.join('&') });
  };

  private onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, from: filterValue } };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, to: filterValue } };
          break;
      }
    } else if (filterField === 'invitationStatus') {
      if (filterValue) nextFilters.invitationStatus = filterValue;
      else {
        delete nextFilters.invitationStatus;
      }
    } else {
      const filter = FILTER_FIELDS_ALL.find(col => col.field === filterField);
      const filterType = filter?.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const optionsEl = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < optionsEl.length; i++) {
          if (optionsEl[i].selected) value.push(optionsEl[i].value);
        }
        nextFilters = { ...nextFilters, [filterField]: value };
      } else {
        nextFilters = { ...nextFilters, [filterField]: filterValue };
      }
    }

    this.setState({ filters: nextFilters });
  };

  private toggleDay = (day: string) => {
    const d = day.toUpperCase();

    this.setState(prev => {
      const current: string[] = Array.isArray(prev.filters.days) ? prev.filters.days : [];
      const next = current.includes(d) ? current.filter(value => value !== d) : [...current, d];
      const filters = { ...prev.filters };
      if (next.length) filters.days = next;
      else delete filters.days;
      return { filters };
    });
  };

  private onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName, basePath } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: basePath, search: parts.join('&') });
  };

  private onClearFilterClick = (): void => {
    this.props.history.push({ pathname: this.state.basePath, search: '' });
  };

  private onChildPickerClick = (childId: string): void => {
    const { children, sortDirection, sortFieldName, basePath } = this.state;

    const nextFilters = {
      ...this.state.filters,
      childIdList: childId === 'all' ? children.map(c => c.id) : [childId]
    };

    this.setState({ filters: nextFilters }, () => {
      const parts: string[] = [];
      if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

      const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
      if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

      this.props.history.push({ pathname: basePath, search: parts.join('&') });
    });
  };

  renderViewMapModal = () => {
    const { isViewMapModalOpen, selectedItem } = this.state;
    const point = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'point']);

    return (
      <SimpleModal isOpen={isViewMapModalOpen} onCloseClick={this.closeViewMapModal} title="View map">
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  openViewMapModal = message => {
    this.setState({ isViewMapModalOpen: true, selectedItem: message });
  };

  closeViewMapModal = () => {
    this.setState({ isViewMapModalOpen: false, selectedItem: undefined });
  };

  renderShowDetailsModal = () => {
    const { isShowDetailsModalOpen, selectedItem } = this.state;
    return (
      <SimpleModal
        isOpen={isShowDetailsModalOpen}
        onCloseClick={this.closeShowDetailsModal}
        title="Club details"
        side="right"
        showFooter={false}
      >
        <ClubBookingDeatils message={selectedItem} />
      </SimpleModal>
    );
  };

  openShowDetailsModal = message => {
    this.setState({ isShowDetailsModalOpen: true, selectedItem: message });
  };

  closeShowDetailsModal = () => {
    this.setState({ isShowDetailsModalOpen: false, selectedItem: undefined });
  };

  openEditResponse = message => this.setState({ selectedItem: message, isEditResponseOpen: true });
  closeEditResponse = () => this.setState({ selectedItem: undefined, isEditResponseOpen: false });
  saveEditedResponse = (fields: MessageField[], priority: number, submission?: FormSubmission) => {
    const { selectedItem } = this.state;
    if (!selectedItem) return;
    this.setState({ isLoading: true });
    updateParentClubAnswers(this.props.user, selectedItem.id, { fields, priority, ...(submission || {}) })
      .then(() => this.setState({ selectedItem: undefined, isEditResponseOpen: false }))
      .then(() => this.setItems());
  };

  onReturnToInboxClick = message => {
    const { user } = this.props;
    this.setState({ isLoading: true });
    cancelRejectionOfParentClubInvitation(user, message.id)
      .then(() => this.setItems())
      .then(() => {
        if (this.props.setNeedUpdate) this.props.setNeedUpdate();
      });
  };

  render() {
    const { user } = this.props;
    const { isLoading, isFiltersOpen, total, currentPage, items, filters, children, sectionCounts } = this.state;
    const archiveSearch = parse(this.props.location.search);
    const hasAppliedArchiveFilters = Object.keys(archiveSearch).some(key => key !== 'page' && key !== 'order');

    if (isLoading) return <Loader />;

    const selectedChildIds =
      filters.childIdList && filters.childIdList.length ? filters.childIdList : children.map(c => c.id);

    const selectedDays: string[] = Array.isArray(filters.days) ? filters.days : [];

    return (
      <main className="parentPage parentListPage parentClubsPage">
        {this.renderShowDetailsModal()}
        {this.renderViewMapModal()}
        <SimpleModal
          isOpen={!!this.state.isEditResponseOpen}
          onCloseClick={this.closeEditResponse}
          title="Edit response"
          side="right"
          showFooter={false}
        >
          <ClubInvitationForm
            user={user}
            message={this.state.selectedItem!}
            onBookNowClick={this.saveEditedResponse}
            closeClubInvitationModal={this.closeEditResponse}
            onAddToWaitingListClick={() => undefined}
          />
        </SimpleModal>

        <ParentPageHeader
          title="Clubs"
          tabs={clubSectionTabs(
            sectionCounts,
            this.props.mode === 'previous' ? 'pastPrevious' : 'pastCurrent',
            this.props.history
          )}
          chips={[{ value: total, label: total === 1 ? 'archived invitation' : 'archived invitations', tone: 'slate' }]}
        />

        <ItemsBar
          items={children}
          itemIdList={selectedChildIds}
          onClick={this.onChildPickerClick}
          allItemsTitle="All children"
          getItemName={(c: any) => `${c.firstName} ${c.lastName}`}
        />

        {this.props.mode !== 'previous' ? (
          <div className="parentHistoryNotice">
            <strong>Showing this academic year</strong>
          </div>
        ) : null}

        <div className="parentListControls">
          <div className="parentListSearch">
            <input
              type="search"
              className="form-control"
              aria-label="Search by club name"
              placeholder="Search club name…"
              value={filters.clubName || ''}
              onChange={e => this.onTableFilterChange(e, 'clubName')}
              onKeyDown={e => {
                if (e.key === 'Enter') this.onApplyFilterClick();
              }}
            />
          </div>
          <button
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>

          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div>

        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'clubName', label: 'Club name' },
            { filterKey: 'sport', label: 'Activity/Sport' },
            { filterKey: 'createdAt', label: 'Invitation date', type: 'date' },
            { filterKey: 'schedule.startDate', label: 'Club start date', type: 'date' },
            {
              filterKey: 'invitationStatus', label: 'Status',
              valueLabels: { ACCEPTED: 'Accepted', REJECTED: 'Declined' }
            },
            {
              filterKey: 'days', label: 'Days', type: 'multi',
              valueLabels: {
                MONDAY: 'Monday', TUESDAY: 'Tuesday', WEDNESDAY: 'Wednesday', THURSDAY: 'Thursday',
                FRIDAY: 'Friday', SATURDAY: 'Saturday', SUNDAY: 'Sunday'
              }
            }
          ]}
        />

        {isFiltersOpen && (
          <div className="parentFilterSurface">
            <ParentFilterBar
              filters={filters}
              showTextFilter={false}
              onTableFilterChange={this.onTableFilterChange}
              onApply={this.onApplyFilterClick}
              onClear={this.onClearFilterClick}
              onCancel={() => this.setState({ isFiltersOpen: false })}
              hint={<>To search the archive by activity or sport, also select an invitation date interval.</>}
              labels={{
                text: 'Club name',
                secondText: 'Activity/Sport',
                date: 'Invitation date',
                secondDate: 'Club start date',
                status: 'Invitation status'
              }}
              fieldKeys={{
                textKey: 'clubName',
                secondTextKey: 'sport',
                dateKey: 'createdAt',
                secondDateKey: 'schedule.startDate',
                statusKey: 'invitationStatus'
              }}
              showStatus
              statusOptions={[
                { value: '', label: 'All' },
                { value: 'ACCEPTED', label: 'Accepted' },
                { value: 'REJECTED', label: 'Declined' },
                { value: 'OUTDATED', label: 'Outdated' }
              ]}
              extraFilters={
                <div className="parentFilterDrawer__field">
                  <label className="form-label">Days of week</label>
                  <div className="parentFilterDrawer__chips">
                    {ALL_DAYS.map(day => (
                      <button
                        key={day}
                        type="button"
                        className={selectedDays.includes(day) ? 'is-selected' : ''}
                        onClick={() => this.toggleDay(day)}
                      >
                        {day.charAt(0) + day.slice(1).toLowerCase()}
                      </button>
                    ))}
                  </div>
                </div>
              }
            />
          </div>
        )}

        {items.length === 0 ? (
          <div className="parentListEmpty">
            {this.props.mode === 'previous' && !hasAppliedArchiveFilters ? (
              <>
                <strong>Search previous academic years</strong>
                <span>Use the filters to find older club invitations without loading your full history.</span>
              </>
            ) : this.props.mode === 'previous' ? (
              <>
                <strong>No club invitations match your filters</strong>
                <span>Try changing or removing one of the filters.</span>
              </>
            ) : (
              <>
                <strong>
                  {hasClubSectionContent(sectionCounts) ? 'No archived club invitations' : 'Nothing here yet'}
                </strong>
                <span>
                  {hasClubSectionContent(sectionCounts)
                    ? 'Use the filters to find an invitation from this academic year.'
                    : 'When your school sends or opens something, you will see it here.'}
                </span>
              </>
            )}
          </div>
        ) : (
          <div className="parentListGrid">
            {items.map(item => {
              const { id } = item;
              return (
                <div className="parentListGrid__item" key={id}>
                  <ClubBookingCard
                    user={user}
                    item={item}
                    type={INVITE_TYPE.ARCHIVE}
                    onViewMapClick={this.openViewMapModal}
                    onShowDetailsClick={this.openShowDetailsModal}
                    onReturnToInboxClick={this.onReturnToInboxClick}
                    onEditClick={this.openEditResponse}
                  />
                </div>
              );
            })}
          </div>
        )}
      </main>
    );
  }
}
